export const REPORT_A_PROBLEM_START = 'REPORT_A_PROBLEM_START';
export const REPORT_A_PROBLEM_FAILED = 'REPORT_A_PROBLEM_FAILED';
export const REPORT_A_PROBLEM_SUCCESS = 'REPORT_A_PROBLEM_SUCCESS';
